/**
 * Tax – Transactions & Add transactions
 */

export default {
  transactions: {
    transactions: "Transactions",
    save: "Save",
    print: "Print",
    fillReturn: "Fill the return",
    addTrans: "Add Transactions",
    allWbs: "All Websites",
    allCntr: "All Countries",
    all: "All",
    showing: "Showing",
    of: "of",
    results: "results",
    confDel: "Confirm Delete",
    areYouSureDel1: "Are you sure you want to delete",
    areYouSureDel2: "",
    del: "Delete",
    close: "Close",
    warning: "Warning",
    planOver: "Your tarrif plan is over",
    contUsing: "You can continue using Lappa software when you subscribe.",
    selectPlan: "select plan",
    transID: "Transaction ID",
    date: "Date",
    time: "Time",
    status: "Status",
    store: "Store",
    country: "Country",
    currency: "Currency",
    sum: "Amount",
    vatRate: "VAT Rate",
    vat: "VAT",
    from: "From",
    till: "Till",
    separateFromTillCalendars:
      "Pick From and Till in separate calendars (single date each)",
    mess: {
      err: {
        part1: "An error occurred while importing transactions from",
        part2: "for the period from",
        part3: "to",
        part4: "by",
        part5: "",
      },
      in: {
        part1: "transaction data for the period from",
        part2: "to",
        part3: "by",
        part4: "during the upgrade process",
      },
      ready: {
        part1: "transaction data for the period from",
        part2: "to",
        part3: "by",
        part4: "has been successfully updated",
      },
    },
    onThisPage:
      "On this page you will find the history of all your transactions",
  },
  addTransactions: {
    transactions: "Transactions",
    addTrans: "Add Transactions",
    website: "Website",
    selectWebsite: "Please select a website",
    transUploaded: "Transaction are successfully uploaded",
    validFrom: "Valid from",
    validTill: "Valid till",
    obtData1: "Obtaining data from",
    obtData2: "",
    sendReq: "Sending request",
    transUpTo: "Transactions data is up to date",
    beReadyUp1: "Be ready",
    beReadyUp2:
      "update can take 5 - 30 minutes - it depends on number of transactions",
    typeOfSales: "Type of sales",
    transImported1: "transactions were successfully imported from",
    transImported2: "",
    digServ: "Digital services",
    goods: "Goods",
    needCalc: "I need to calculate tax for these transactions",
    haveAll: "I have all tax calculated",
    firstDataRow: "First data row number",
    lastDataRow: "Last data row number",
    validFormats: "Valid file formats",
    goTrans1: "Go to the",
    goTrans2: "transactions section",
    goTrans3: "and set your period to see the uploaded transactions",
    addFile: "Add file",
    fileName: "file name",
    chooseFiles: "choose *.xlsx, *.xls files to upload",
    chooseRows: "Choose first data and last data row",
    matchEach:
      "Match each column in your import file with system headers. Showing first data row from your file",
    learnMore: "Learn more about adding transactions",
    params: "Parameters",
    fileHeaders: "File Column Headers",
    transPrev: "Transaction Preview",
    consThresh: "Consider thresholds for VAT calculation",
    lastUpload: "Last uploading from",
    was: "was",
    howUpload: "How to Upload",
    chooseImportParams: "Choose import parameters",
    discard: "Discard",
    next: "Next",
    uploadTrans: "Upload transactions",
    importTrans: "Import transactions",
    chooseFile: "Choose file",
    selectRange: "Select range",
    colMatch: "Columns matching",
    hereYouCanAdd: "Here you can add your transactions",
  },
};
